import * as React from "react";
// import * as Load from "./load";
import { SingleLoadView, MultiLoadView } from "./components";
import { LoadDef, Props, ErrorSeverity } from "./types";
import { State } from "./state";
import { GetErrorSeverity as ErrorSeverityCheck } from "./tools";
import { PropertyValueSet } from "@genesys/property";

export function View(props: Props) {
  const { viewMode } = props;

  if (viewMode === "row") {
    return <MultiLoadView {...props} />;
  } else if (viewMode === "grid") {
    return <SingleLoadView {...props} />;
  }

  return <div>Unknown view mode</div>;
}

export function GetErrorSeverity(
  state: State,
  loadDef: LoadDef,
  currentTopLevelMoistureLoadSettings: PropertyValueSet.PropertyValueSet
): ErrorSeverity {
  return ErrorSeverityCheck(
    state,
    loadDef,
    currentTopLevelMoistureLoadSettings
  );
}
